export const GET_VERIF = 'TIER_TWO/GET_VERIF'
export const SUBMIT = 'TIER_TWO/SUBMIT'
export const SYNC_VERIFF = 'TIER_TWO/SYNC_VERIFF'
